module.exports = __webpack_public_path__ + "img/swiper_3.0_6_1.9f5eedaf.webp";